import React, { useLayoutEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Loader from './components/Loader'
import AppRouter from './components/AppRouter'
import MainLayout from './components/MainLayout'
import {
    getAppCategories,
    getAppStatuses,
    getCdnConfiguration,
} from 'app/services/client'
import { setAppCategories, setAppStatuses } from 'app/state/appSlice'
import { setCdnInfo } from './state/generalSlice'
import { RootState } from './state/types'
import { handleServerAPIError } from './services/utils'
import './main.scss'

const App = () => {
    const { appCategories, appStatuses } = useSelector(
        (state: RootState) => state.appSlice,
    )
    const dispatch = useDispatch()
    const navigate = useNavigate()

    useLayoutEffect(() => {
        if (appCategories.length < 1 && appStatuses.length < 1) {
            Promise.all([getAppCategories(), getAppStatuses()])
                .then(res => {
                    dispatch(setAppCategories(res[0].data))
                    dispatch(setAppStatuses(res[1].data))
                })
                .catch(e => handleServerAPIError(e, dispatch, navigate))
        }

        getCdnConfiguration()
            .then(res => dispatch(setCdnInfo(res.data)))
            .catch(e => handleServerAPIError(e, dispatch, navigate))
    }, [])

    return (
        <MainLayout>
            <Loader />
            <AppRouter />
        </MainLayout>
    )
}

export default App
